module.exports = __webpack_public_path__ + "img/bg.b5ccf1f0.jpg";